import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type CloseQuestionnaireModalProps = InheritableModalProps & {
  onAction: () => void
}

const CloseQuestionnaireModal = ({ onAction, ...props }: CloseQuestionnaireModalProps) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <FontAwesomeIcon icon={['fal', 'question-circle']} fontSize={24} />

        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {t({
            id: 'questionnaire.modal.close.title',
            comment: 'Modal title',
            message: 'Vragenlijst sluiten',
          })}
        </H3>

        <P
          type='BodyLargeRegular'
          textAlign='center'
          color={theme.Colors.Neutrals.Darker}
          style={{ marginBottom: theme.UI.Spacing.Space6 }}
        >
          {t({
            id: 'questionnaire.modal.close.body',
            comment: 'Modal body',
            message:
              'Ben je zeker dat je wilt afsluiten? Je voortgang wordt opgeslagen en je kan de vragenlijst later vervolledigen.',
          })}
        </P>
        <Button variant='Primary' onClick={onAction}>
          {t({
            id: 'questionnaire.modal.close.secondary',
            comment: 'Modal secondary button',
            message: `Bewaar en doe later verder`,
          })}
        </Button>
        <Margin mt={theme.UI.Spacing.Space2} />
        <Button variant='Tertiary' onClick={props.onClose}>
          {t({
            id: 'questionnaire.modal.close.primary',
            comment: 'Modal primary button',
            message: `Toch vervolledigen`,
          })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}

export { CloseQuestionnaireModal }
